import { Navigate } from 'react-router-dom';
import { ROLES } from '@bcc/shared';
import { useAuth } from '../contexts/AuthContext';
import { AdminDashboard } from './AdminDashboard';

/** `/admin` — full console for admins; staff is redirected to CRM. */
export function AdminEntry() {
  const { role } = useAuth();
  if (role === ROLES.ADMIN) return <AdminDashboard />;
  return <Navigate to="/admin/crm" replace />;
}
